import { RouteLocationNormalized } from 'vue-router'

import { RTCSessionFacade, useWebRTC } from '@/shared/services/jssip'

interface Result {
  rtcSessionFacade?: RTCSessionFacade
}

export function callSessionPropsFn (to: RouteLocationNormalized): Result {
  const { sessionId: sessionIdParam } = to.params
  let sessionId

  if (Array.isArray(sessionIdParam)) {
    sessionId = sessionIdParam[0]
  } else {
    sessionId = sessionIdParam
  }

  const { getRTCSessionFacadeById } = useWebRTC()
  const rtcSessionFacade = getRTCSessionFacadeById(sessionId!)

  return {
    rtcSessionFacade: rtcSessionFacade!,
  }
}
